import React from 'react'
import { TabNavigation, TabNavigationItem } from '@pandiafi/design-system'
import { useLocation, useNavigate } from 'react-router-dom'

interface NavRoute {
  path: string
  label: string
}

interface NavBarProps {
  routes: NavRoute[]
}

export const NavBar: React.FC<NavBarProps> = ({ routes }) => {
  const location = useLocation()
  const navigate = useNavigate()

  const handleTabChange = (path: string) => navigate(path)

  return (
    <TabNavigation
      fullwidth
      onChange={handleTabChange}
      selected={location.pathname}
    >
      {routes.map((route) => (
        <TabNavigationItem
          key={route.path}
          id={route.path}
          onPress={() => handleTabChange(route.path)}
        >
          {route.label}
        </TabNavigationItem>
      ))}
    </TabNavigation>
  )
}
